import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeStyle as _normalizeStyle, withCtx as _withCtx, createBlock as _createBlock, TransitionGroup as _TransitionGroup, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "items-alert"
}
const _hoisted_2 = ["src"]
const _hoisted_3 = { class: "alert-text" }
const _hoisted_4 = { class: "items-scroll" }
const _hoisted_5 = {
  key: 1,
  class: "items-placeholder"
}
const _hoisted_6 = { class: "placeholder-content" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ButtonShop = _resolveComponent("ButtonShop")!
  const _component_ItemOverlay = _resolveComponent("ItemOverlay")!
  const _component_Item = _resolveComponent("Item")!
  const _component_Spinner = _resolveComponent("Spinner")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["profile-items", { loading: _ctx.loading }])
  }, [
    (!_ctx.loading)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          (_ctx.items.length)
            ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("img", {
                  src: require('../../assets/icons/items_alert.svg'),
                  class: "alert-icon"
                }, null, 8, _hoisted_2),
                _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.t('Items.alert')), 1),
                _createVNode(_component_ButtonShop, { class: "top-shop-btn" })
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_TransitionGroup, {
              tag: "div",
              class: "items-wrap",
              appear: ""
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.items, (item, i) => {
                  return (_openBlock(), _createBlock(_component_Item, {
                    class: "item-wrap",
                    style: _normalizeStyle({ '--delay': `${i * 75}ms` }),
                    key: item.id,
                    id: item.id,
                    icon: item.item.icon,
                    type: item.item.type,
                    name: item.item.name,
                    price: item.item.priceUsd,
                    color: item.item.color,
                    volume: 
							item.buyPriceUsd && item.item.priceUsd > item.buyPriceUsd
								? 0
								: item.item.marketVolume || 0
						,
                    stattrak: item.item.stattrak,
                    exterior: item.item.exterior,
                    hoverable: false,
                    noHover: true
                  }, {
                    overlay: _withCtx(() => [
                      _createVNode(_component_ItemOverlay, {
                        withdrawBtn: !item.gamesCount,
                        error: item.withdraw ? item.withdraw.errorMessage : null,
                        status: item.status,
                        timerEndsAt: item.timerEndsAt,
                        onSell: ($event: any) => (_ctx.sell(item.id)),
                        onWithdraw: ($event: any) => (_ctx.withdraw(item.id)),
                        onOffer: ($event: any) => (_ctx.offer(item.id))
                      }, null, 8, ["withdrawBtn", "error", "status", "timerEndsAt", "onSell", "onWithdraw", "onOffer"])
                    ]),
                    _: 2
                  }, 1032, ["style", "id", "icon", "type", "name", "price", "color", "volume", "stattrak", "exterior"]))
                }), 128))
              ]),
              _: 1
            })
          ]),
          (!_ctx.items.length)
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, [
                  _createTextVNode(_toDisplayString(_ctx.t('Items.placeholder')) + " ", 1),
                  _cache[0] || (_cache[0] = _createElementVNode("br", null, null, -1)),
                  _createVNode(_component_ButtonShop, { class: "button-shop-wrap success-dark" })
                ])
              ]))
            : _createCommentVNode("", true)
        ], 64))
      : _createCommentVNode("", true),
    (_ctx.loading)
      ? (_openBlock(), _createBlock(_component_Spinner, {
          key: 1,
          width: "64px",
          height: "64px",
          class: "spinner-wrap"
        }))
      : _createCommentVNode("", true)
  ], 2))
}